import { render, staticRenderFns } from "./RegisterUserModal.vue?vue&type=template&id=345ba060&"
import script from "./RegisterUserModal.vue?vue&type=script&lang=js&"
export * from "./RegisterUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports